module.exports = __webpack_public_path__ + "static/media/DOLE.ac18c595.png";